import { useQuery } from '@tanstack/react-query'
import { aiApi } from '@/api/client'

/**
 * Shared AI/Ollama health probe. Polls every 15s and on window focus so the
 * UI can reactively gate features (source attachment, pulls) when the local
 * server goes down.
 */
export function useAiHealth() {
  return useQuery({
    queryKey: ['ai-health'],
    queryFn: aiApi.health,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  })
}
